import React, { Component } from "react";
import { CustomDialog } from "../MarkOrder.style";
import {
  Button,
  DialogTitle,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";

export class DialogMark extends Component {
  setSourceForBox = () => {
    if (this.props.packageId === 181) {
      this.props.markBoxVerifedHandler("CHECKER_PWA");
    } else if (this.props.packageId === 231) {
      this.props.onChangeBoxStatusHandler(null);
    } else if (this.props.packageId === 182) {
      this.props.onChangeBoxStatusHandler("ADMIN_PACKAGE_TRACKER");
    } else if (this.props.packageId === 179) {
      this.props.onChangeBoxStatusHandler(null);
    } else {
      return false;
    }
  };
  render() {
    let { dialogToggle, handleClose, loaderStatus } = this.props;

    return (
      <CustomDialog
        open={dialogToggle}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"md"}
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
          <Button
            onClick={() => this.setSourceForBox()}
            variant="contained"
            color="primary"
            disabled={loaderStatus}
          >
            {loaderStatus ? <CircularProgress size={20} /> : "Yes"}
          </Button>
        </DialogActions>
      </CustomDialog>
    );
  }
}

export default DialogMark;
